import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Lux_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalOpticas = () => {
  return (
    <>
      <ModalVideo
        id="spot-opticas"
        dataText={Lux_Title}
        videoSrc="https://player.vimeo.com/video/748109033?h=ea73dcb3b7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_OPTICAS_LUX"
      />
    </>
  );
};

export default ModalOpticas;
